import MUIDataTable from "mui-datatables";
import Cookies from 'js-cookie';
import React from "react";
import { getUserDefault } from "../services/Form";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import { getTableData } from "../services/City";
import GoogleMapReact from "google-map-react";
import MyMarker from "./MyMarker";
import Marker from "./Marker";
import CustomInfoWindow from "./CustomInfoWindow";

import Sidebar from '../components/Sidebar'
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import {
  Box,
  Button,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
  Dialog,
  DialogActions,
  Typography,
} from "@material-ui/core";
import { deleteFormData } from "../services/Form";

let Arr = [];
const columns = [
  {
    name: "Address1",
    options: {
      display: false,
      filter: false,
      sort: false,
    },
  },
  {
    name: "Address",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "Creator",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "Date Created",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "",
    options: {
      filter: false,
      sort: false,
    },
  },
];
const columns1 = [

  {
    name: "Address",
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: "",
    options: {
      filter: false,
      sort: false,
    },
  },
];
let options1 = {
  filterType: "",
  download: false,
  print: false,
  selectableRowsHeader: false,
  viewColumns: false,
  selectableRows: false,

  search: false,
  rowsPerPage: [10],
  rowsPerPageOptions: [10]
};
// const options = {
//   filterType: "",
//   download: false,
//   print: false,
//   selectableRowsHeader: false,
//   viewColumns: false,
//   selectableRows: false,
// };
let options = {
  filterType: "",
  download: false,
  print: false,
  selectableRowsHeader: false,
  viewColumns: false,
  selectableRows: false,
  rowsPerPage: [20],
  rowsPerPageOptions: [20],
  // Search ALL columns, including hidden fields that use display:false, viewColumns:false...
  customSearch: (searchQuery, currentRow, columns) => {
    let isFound = false;
    currentRow.forEach(col => {
      if (col && col.toString().indexOf(searchQuery) >= 0) {
        isFound = true;
      }
    });
    return isFound;
  },
  customSort: (data, colIndex, order) => {


    return data.sort((a, b) => {
      if (order === "desc") {
        return (
          (a.form_id < b.form_id ? 1 : -1)
        );
      } else {
        return (
          (a.form_id > b.form_id ? 1 : -1)
        );
      }
    });
  },

}
function Main() {
  let username = Cookies.get('username');

  const history = useHistory();
  const location = useLocation();
  const [goods, setGoods] = React.useState(null);
  const [formData, setFormData] = React.useState(null);
  const [formData1, setFormData1] = React.useState(null);
  const [modalShow, setModalShow] = React.useState(false);
  const [selected, setSelected] = React.useState(null);
  const [SortVal, setSortVal] = React.useState(0);
  const [value2, setValue2] = React.useState("Undefined");
  const [selectedCenter, setSelectedCenter] = React.useState(null)

  const handleShowInfo = location => {
    setSelectedCenter(location)
    console.log(location)
  }
  const ref = React.useRef(null);
  React.useEffect(() => {
    console.log(ref.current);
    getUserDefault().then(async (res) => { });
  }, [ref]);

  function ChangeBounds(props) {


    console.log("hete", props);
    if (props != null) {

      setFormData1(goods.filter(marker => {
        if (
          Number(marker.Latitude.slice(1, marker.Latitude.length - 1)) > props.ab.lo && props.ab.lo &&
          (Number(marker.Latitude.slice(1, marker.Latitude.length - 1)) < props.ab.hi && props.ab.hi) &&
          (Number(marker.Longitude.slice(1, marker.Longitude.length - 1)) > props.Fa.lo && props.Fa.lo) &&
          (Number(marker.Longitude.slice(1, marker.Longitude.length - 1)) < props.Fa.hi && props.Fa.hi)
        )
          return marker;
      }));

    }

  }
  function handleChange(props) {


    console.log("hete", props);
    if (props != null) {
      if (props.bounds.ne.lng != undefined) {
        setFormData1(goods.filter(marker => {
          if (
            Number(marker.Latitude.slice(1, marker.Latitude.length - 1)) > props.bounds.se.lat &&
            props.bounds.sw.lat &&
            (Number(marker.Latitude.slice(1, marker.Latitude.length - 1)) < props.bounds.ne.lat && props.bounds.nw.lat) &&
            (Number(marker.Longitude.slice(1, marker.Longitude.length - 1)) > props.bounds.nw.lng && props.bounds.sw.lng) &&
            (Number(marker.Longitude.slice(1, marker.Longitude.length - 1)) < props.bounds.ne.lng && props.bounds.se.lng)
          )
            return marker;
        }));
      }
      else {
        props.size.height = 300;
      }
    }

  }

  React.useEffect(() => {
    (async () => {
      if (value2 != 'Undefined') {
        /// console.log(value2);
        geocodeByAddress(value2.label)
          .then((results) => getLatLng(results[0]))
          .then(({ lat, lng }) => {
            console.log("Successfully got latitude and longitude", {
              lat,
              lng,
            });
            onChange(lat, lng);
          });
      }
    })();
  }, [value2]);

  function dataSort() {
    if (SortVal == 0) {
      setFormData(formData.sort((a, b) => a.form_id < b.form_id ? 1 : -1));
      setGoods(goods.sort((a, b) => a.form_id < b.form_id ? 1 : -1));
      console.log(goods);
      setSortVal(1);
    }

    if (SortVal == 1) {
      setFormData(formData.sort((a, b) => a.form_id > b.form_id ? 1 : -1));
      setGoods(goods.sort((a, b) => a.form_id > b.form_id ? 1 : -1));
      console.log(goods);
      setSortVal(0);
    }

  }
  React.useEffect(() => {
    getTableData().then((res) => {
      setFormData(res);
      setFormData1(res);
      setGoods(res);
    });

  }, []);
  function handleChanePass() {

    history.push('/changePassword')
  }
  function handleSelectionCity() {

    history.push('/')
  }

  function handleLogout() {
    Cookies.remove('username')
    Cookies.remove('city')
    Cookies.remove('UsedClicks')
    Cookies.remove('PerMonthClick')
    history.push('/login')
  }
  function OnClickSetMapHeight() {
    console.log("hereeeee");
    //SetMapHeight("80vh");
  }

  const defaultMapOptions = {
    fullscreenControl: false,
  };
  const onChange = (lat, lng) => {

    // setValue(e.target.value);
    console.log("here", value2);
    Cookies.set('searchString', value2.label)
    window.location.reload(false);
  };

  const [loading, setLoading] = React.useState(false)

  return (
    <div id="wrapper" class="main_dashboard">
      <Sidebar main={"side-icon "} home={"side-icon active"} pass={"side-icon "} screen="Main" />

      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content" >

          <div class="container-fluid">

            <div class="row  mb-2" >
              <div class="col-md-9 page-content-section">
                <div class="table-content-propaty">
                  <div class="heading-propaty">
                    <div class="row" style={{ width: "100%" }}>
                      <div class="col-md-6">
                        <h2>Seattle Properties</h2>
                      </div>
                      <div class="col-md-6"><ul class="nav nav-tabs" id="myTab" role="tablist" style={{ float: "right" }}>
                        <li class="nav-item" role="presentation">
                          <a class="nav-link active" id="billing-tab" data-toggle="tab" href="#billing" role="tab" aria-controls="billing" aria-selected="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24.402" height="22.678">
                              <path d="M0 9.45h9.45V0H0v9.45Zm0 13.228h9.45v-9.45H0v9.45ZM11.34 5.67v1.89h13.062V5.67H11.339Zm13.062 9.449H11.339v1.89h13.063v-1.89Zm-13.063 5.67h13.063v-1.89H11.339v1.89Zm13.063-17.01H11.339V1.89h13.063v1.89Z" fill="#1d1c1d" fill-rule="evenodd" data-name="layout-list-thumb-alt-svgrepo-com" />
                            </svg><span > List</span>
                          </a>
                        </li>
                        <li class="nav-item" role="presentation" >
                          <a class="nav-link" id="payment-tab" data-toggle="tab" href="#payment" role="tab" aria-controls="payment" aria-selected="false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="22.678">
                              <path d="m7.143 22.072.527.606.527-.608a15.945 15.945 0 0 0 .124-.145c.98-1.158 7.018-8.53 7.018-14.255C15.34 3.44 11.898 0 7.67 0 3.443 0 0 3.44 0 7.67a10.218 10.218 0 0 0 .26 2.198c1.144 5.173 5.736 10.841 6.71 12a19.351 19.351 0 0 0 .173.204Zm-.033-2.263a43.027 43.027 0 0 0 .56.71c1.598-1.985 6.275-8.202 6.275-12.85A6.283 6.283 0 0 0 7.67 1.395 6.283 6.283 0 0 0 1.395 7.67a8.514 8.514 0 0 0 .158 1.577c.737 3.896 3.87 8.372 5.557 10.562ZM7.67 3.68a4.188 4.188 0 0 0-4.184 4.183 4.188 4.188 0 0 0 4.184 4.184 4.188 4.188 0 0 0 4.183-4.184A4.188 4.188 0 0 0 7.67 3.68ZM4.88 7.863a2.792 2.792 0 0 0 2.79 2.79 2.792 2.792 0 0 0 2.789-2.79 2.792 2.792 0 0 0-2.79-2.789 2.792 2.792 0 0 0-2.788 2.79Z" fill="#1d1c1d" fill-rule="evenodd" data-name="location-pin-svgrepo-com" />
                            </svg>  <span> Map</span></a>
                        </li>

                      </ul></div>
                    </div>

                  </div>

                  <div class="tab-content" id="myTabContent" style={{ width: "100%", backgroundColor: "White" }}>
                    {formData === null ? <Loader /> :
                      <>
                        <div class="card tab-pane fade active show" id="billing" role="tabpanel" aria-labelledby="billing-tab">
                          {formData && (
                            <>
                              <MUIDataTable
                                style={{
                                  backgroundcolor: "black !important",
                                  color: "white !important",
                                }}
                                title={"Registered Properties"}
                                data={
                                  formData &&
                                  formData.map((item, index) => {
                                    return {
                                      "Address1": item.form_name.slice(1, item.form_name.length - 1),
                                      Address: <>    <div class="row">
                                        <div class="col-md-3 col-5" style={{ height: "10vh", marginLeft: "2%" }}>
                                          <GoogleMapReact
                                            bootstrapURLKeys={{ key: "" }}
                                            center={[Number(item.Latitude.slice(1, item.Latitude.length - 1)), Number(item.Longitude.slice(1, item.Longitude.length - 1))]}
                                            defaultZoom={11}
                                            yesIWantToUseGoogleMapApiInternals
                                            options={defaultMapOptions}
                                            style={{ height: "1vh" }}
                                          >
                                            <MyMarker key={item.form_id} lat={Number(item.Latitude.slice(1, item.Latitude.length - 1))} lng={Number(item.Longitude.slice(1, item.Longitude.length - 1))} text={""} tooltip={item.form_name.slice(1, item.form_name.length - 1)} />
                                          </GoogleMapReact></div>
                                        <div class="col-md-8 col-6" style={{ margin: "auto" }}>
                                          <a style={{ color: "#2d68b2" }} href="" onClick={() =>
                                            history.push("/form/" + btoa(item.form_id + "_" + username), {
                                              form_id: btoa(item.form_id + "_" + username),
                                            })
                                          }>


                                            <u>{item.form_name.slice(1, item.form_name.length - 1)}</u></a>
                                        </div> </div></>,
                                      Creator: item.form_creator,
                                      "Date Created": item.form_creation_date,
                                      "": (
                                        <>

                                          <button onClick={() =>
                                            history.push("/view/" + btoa(item.form_id + "_" + username), {
                                              form_id: btoa(item.form_id + "_" + username),
                                            })
                                          } class="report btn btn-primary">Report</button>
                                          <a onClick={() => {
                                            setSelected(item.form_id);
                                            setModalShow(true);
                                          }} href="javascript:void(0);">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25.339" height="22.678">
                                              <path class="cls-15" d="M16.809,3a2.628,2.628,0,0,0-5.1,0H6.993v1.32H21.516V3H16.809Zm-2.555-.681A1.344,1.344,0,0,1,15.41,3H13.122A1.3,1.3,0,0,1,14.255,2.319Zm5.281,3.3h1.32V19.5a1.983,1.983,0,0,1-1.98,1.98H9.633a1.983,1.983,0,0,1-1.98-1.98V5.62h1.32V19.5a.661.661,0,0,0,.66.66h9.242a.661.661,0,0,0,.66-.66V5.62Zm-6.6,1.32V17.5h-1.32V6.94Zm3.961,0V17.5h-1.32V6.94Z" />
                                            </svg>
                                          </a>
                                        </>
                                      ),
                                    };
                                  })
                                }
                                columns={columns}
                                options={options}
                              />



                            </>
                          )}
                          {/* <div class="table-responsive text-nowrap table-boxs">
                              <table class="cell-border table table-hover table-center" id="example">
                                 <thead>
                                    <tr>
                                       <th>Address</th>
                                       <th>Creator</th>
                                       <th>Date Created <span onClick={dataSort} class="fa fa-angle-up"></span></th>
                                       <th></th>
                                    </tr>
                                 </thead>
                                  <tbody>  
                                  {goods && goods.map((item) => (
                                  <tr>
                                  <td>
                                 
                               
                                  <div class="row">
                                  <div class="col-md-3" style={{height:"10vh",marginLeft:"2%"}}>
                                  <GoogleMapReact
                                  bootstrapURLKeys={{ key: "" }}
                                  center={[Number(item.Latitude.slice(1, item.Latitude.length - 1)), Number(item.Longitude.slice(1, item.Longitude.length - 1))]}
                                  defaultZoom={11}
                                  yesIWantToUseGoogleMapApiInternals 
                                  options={defaultMapOptions}      
                                  style={{height:"1vh"}}
                                  >
                                  <MyMarker key={item.form_id} lat={Number(item.Latitude.slice(1, item.Latitude.length - 1))} lng={Number(item.Longitude.slice(1, item.Longitude.length - 1))} text={""} tooltip={item.form_name.slice(1, item.form_name.length - 1)} />  
                                  </GoogleMapReact></div>
                               <div class="col-md-8" style={{margin:"auto"}}> 
                                 <a style={{color:"#2d68b2"}} href="" onClick={() =>
                          history.push("/form/" + item.form_id, {
                            form_id: item.form_id,
                          })
                        }>
                          
                          
                          <u>{item.form_name.slice(1, item.form_name.length - 1)}</u></a>
                                  </div> </div>
                               
                                  </td>
                                  <td>{item.form_creator}</td>
                                  <td>{item.form_creation_date}</td>
                                  <td>
                                  <button onClick={() =>
                                  history.push("/view/" + item.form_id, {
                                  form_id: item.form_id,
                                  })
                                  } class="report btn btn-primary">Report</button>
                                  <a  onClick={() => {
                                  setSelected(item.form_id);
                                  setModalShow(true);}} href="javascript:void(0);">
                                  <img class="delete" src="assets/img/trash-svgrepo-c.png" alt="trash-svgrepo-c.png"></img>
                                  </a>
                                  </td>
                                  </tr>
                                  ))}
                                  </tbody>
                              </table>
                           </div> */}
                        </div>


                        <div class="tab-pane fade card" id="payment" role="tabpanel" aria-labelledby="payment-tab">


                          <div class="row card-body" style={{ paddingLeft: "0px", paddingRight: "0px" }}>

                            <div class="col-md-7 col-12 first-div" style={{ boxShadow: "none", padding: "0px" }}>
                              {formData1 && (
                                <MUIDataTable
                                  style={{
                                    backgroundcolor: "black !important",
                                    color: "white !important",
                                  }}
                                  title={"Registered Properties"}
                                  data={
                                    formData1 && formData1.map((item, index) => {
                                      return {
                                        "Address": <div style={{ padding: "1rem" }}>
                                          <span class="dot" ></span>
                                          <a style={{ marginLeft: "4%", color: "#2d68b2" }} href="" onClick={() =>
                                            history.push("/form/" + btoa(item.form_id + "_" + username), {
                                              form_id: btoa(item.form_id + "_" + username),
                                            })
                                          }><u>{item.form_name.slice(1, item.form_name.length - 1)}</u></a>

                                        </div>
                                        ,

                                        "": (
                                          <>
                                            <button onClick={() =>
                                              history.push("/view/" + btoa(item.form_id + "_" + username), {
                                                form_id: btoa(item.form_id + "_" + username),
                                              })
                                            } class="report report1 btn btn-primary">Report</button>

                                          </>
                                        ),
                                      };
                                    })
                                  }
                                  columns={columns1}
                                  options={options1}
                                />
                              )}


                            </div>

                            <div class="col-md-5 col-12 second-div mb-3 second-div1" >


                              <GoogleMapReact
                                ref={ref}
                                bootstrapURLKeys={{ key: "" }}
                                defaultCenter={{ lat: 47.6062095, lng: -122.3320708 }}
                                defaultZoom={11}

                                mapType={"hybrid"}
                                yesIWantToUseGoogleMapApiInternals

                                onDragEnd={(e) => {
                                  let props = ref.current.map_;
                                  ChangeBounds(props.getBounds());
                                }}
                                onZoomAnimationEnd={(e) => {
                                  let props = ref.current.map_;
                                  ChangeBounds(props.getBounds());
                                  console.log("i'm heremm ", props.getBounds());

                                }}


                              >



                                {formData.map((item) => {

                                  var lat = Number(item.Latitude.slice(1, item.Latitude.length - 1));
                                  var lng = Number(item.Longitude.slice(1, item.Longitude.length - 1));
                                  var id = item.form_id;
                                  var title = item.form_name.slice(1, item.form_name.length - 1);

                                  const airPortHH = {
                                    Name: title,
                                    id: id,
                                    lat: lat,
                                    lng: lng,
                                  }
                                  return (

                                    //  <MyMarker key={id} lat={lat} lng={lng} text={id} tooltip={title} 



                                    //  />

                                    <Marker
                                      id={id}
                                      lat={lat}
                                      lng={lng}
                                      showInfo={() => handleShowInfo(airPortHH)}
                                    />
                                  );
                                })}
                                {selectedCenter && (
                                  <CustomInfoWindow
                                    lat={selectedCenter.lat}
                                    lng={selectedCenter.lng}
                                    Name={selectedCenter.Name}
                                    id={selectedCenter.id}
                                    close={() => {
                                      setSelectedCenter(null)
                                    }}
                                    position={{
                                      lat: selectedCenter.lat,
                                      lng: selectedCenter.lng,
                                      Name: selectedCenter.Name,
                                      id: selectedCenter.id,
                                    }}
                                  />
                                )}


                              </GoogleMapReact>


                            </div>
                          </div>

                        </div>
                      </>
                    }
                  </div>

                </div>

                <Dialog
                  open={modalShow}
                  onClose={() => setModalShow(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title" style={{ backgroundColor: "#2967B2", textDecoration: "white" }}>Delete Property</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description" >
                      <br />
                      Are you sure want to delete this property ?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <button
                      onClick={() => setModalShow(false)}
                      class="btn btn-primary"
                      style={{ margin: "1%", padding: "9px", backgroundColor: "#2967B2" }}
                    >
                      <span>Close</span>
                    </button>
                    <button
                      onClick={() => {
                        if (selected) {
                          setLoading(true);
                          deleteFormData(selected).then((res) => {
                            setModalShow(false);
                            setLoading(false)
                            window.location.reload()
                          });

                        }
                      }}
                      class="btn btn-danger"
                      style={{ margin: "1%", padding: "9px" }}
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          class="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}Delete
                    </button>
                  </DialogActions>
                </Dialog>
              </div>

              <div class="col-md-3 city-dashboard img Landbrige_map" >
                <div class="bg_content">
                  <img src="assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
                  <h2>land analysis made simple</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>






  );

}

export default Main;
